var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 45,
    viewBox: "0 0 39 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.2453 38.8717C32.2064 40.4059 27.1498 13.2936 27.1498 13.2936C27.1498 13.2936 -0.560673 13.2402 5.05443 34.526C-0.284297 28.0013 -0.444664 18.4047 5.13291 11.665C11.4702 4.00634 22.8165 2.93499 30.4754 9.27322C38.1343 15.6114 39.2046 26.9572 32.8672 34.6159C27.2442 41.4102 17.6802 43.0195 10.2453 38.8706V38.8717Z",
    stroke: "black",
    strokeWidth: 1.89474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.7893 19.3506C22.7893 19.3506 15.2465 34.9045 2.89453 38.298",
    stroke: "black",
    strokeWidth: 1.89474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElements);
export default __webpack_public_path__ + "static/media/elements.e4e3aa4e445830a90da8c59fb838222e.svg";
export { ForwardRef as ReactComponent };